// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nXyo","question":"styles_question__3EuPq","description":"styles_description__evhEk"};